// What kind of browser this is, for the install guide. Install is per platform: iOS only offers
// Add to Home Screen from Safari's Share sheet, Chromium on Android offers a real prompt.

/** True when Pointz is running as the installed app rather than in a browser tab. */
export function isStandalone(): boolean {
  // iOS Safari reports it on navigator.standalone; everything else uses the display-mode query.
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return iosStandalone || window.matchMedia("(display-mode: standalone)").matches;
}

export function isIos(): boolean {
  // iPadOS 13+ reports a desktop Mac user agent, so a touch-capable "Mac" counts as iOS too.
  const ua = navigator.userAgent;
  if (/iphone|ipad|ipod/i.test(ua)) return true;
  return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
}

/** On iOS, Add to Home Screen lives in Safari; Chrome, Firefox and Edge there cannot install. */
export function isIosSafari(): boolean {
  return isIos() && !/crios|fxios|edgios/i.test(navigator.userAgent);
}

export function isAndroid(): boolean {
  return /android/i.test(navigator.userAgent);
}
